export const getActivityQuestionLink = ({
  companyId,
  assessmentId,
  businessUnitId,
  activityReference,
  questionId,
}: {
  companyId: string;
  assessmentId: string;
  businessUnitId: string;
  activityReference?: string;
  questionId?: string;
}) => {
  return `/${companyId}/assessments/${assessmentId}/screening/${businessUnitId}/${activityReference}/${questionId}`;
};

export const getDisclosureRequirementLink = ({
  companyId,
  assessmentId,
  standardRef,
  disclosureRequirement,
  framework,
}: {
  companyId: string;
  assessmentId: string;
  standardRef?: string;
  disclosureRequirement?: {
    reference?: string;
    type: string;
    group?: {
      standardRef: string;
    };
  };
  framework: string;
}) => {
  return `/${companyId}/sustainability-reporting/${framework}/${assessmentId}/standard/${standardRef}/disclosure-requirement/${disclosureRequirement?.type}/${disclosureRequirement?.reference}`;
};

export const getStandardConfigLink = (
  {
    companyId,
    assessmentId,
    standardRef,
    framework,
  }: {
    companyId: string;
    assessmentId: string;
    standardRef?: string;
    framework: string;
  },
  isOnboarding?: boolean
) => {
  return `/${companyId}/sustainability-reporting/${framework}/${assessmentId}/${isOnboarding ? 'onboarding' : 'settings'}/data-collection/${standardRef}`;
};

export const getBUDisclosureRequirementLink = ({
  companyId,
  assessmentId,
  businessUnitId,
  standardRef,
  disclosureRequirement,
  framework,
}: {
  companyId: string;
  assessmentId: string;
  businessUnitId: string;
  standardRef?: string;
  disclosureRequirement?: {
    reference: string;
    type: string;
    group?: {
      standardRef: string;
    };
  };
  framework: string;
}) => {
  return `/${companyId}/sustainability-reporting/${framework}/${assessmentId}/bu-standard/${standardRef}/bu/${businessUnitId}/disclosure-requirement/${disclosureRequirement?.reference}`;
};
